import { useMutation } from '@tanstack/react-query';
import { useSnackbar } from '../Stateless/SnackBarProvider';
import { useSetNewPasswordApi } from '../../hooks/useSetNewPasswordApi';

export const useSetNewPassword = () => {
  //   const queryClient = useQueryClient();
  const { showMessage } = useSnackbar();
  const { createNewPassword } = useSetNewPasswordApi();
  return useMutation({
    mutationKey: ['CreateChoice'],
    mutationFn: (data: any) => createNewPassword(data),
    onSuccess: (response: any) => {
      showMessage(
        response?.message || 'Password successfully reset',
        'success'
      );
      //   queryClient.invalidateQueries({
      //     queryKey: ['getChoices'],
      //     exact: false,
      //   });
    },
    onError: (error: any) => {
      showMessage(error.response?.data?.message || 'Failed to login', 'error');
    },
  });
};
